import { roundCloseButton, leftButton, rightButton } from '@project/theme-buttons'

export const gallery2Theme = {
  closeButton: roundCloseButton,
  rightButton,
  leftButton,
  suspendScrolling: true
}